<template>
  <ZigzagServiceLayout
    mainTitle="Telemedicina: Atención Accesible Donde Quiera Que Esté"
    mainDescription="Experimente atención médica de alta calidad desde la comodidad de su hogar. Nuestra plataforma de telesalud lo conecta con profesionales para consultas, seguimientos y tratamientos especializados."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'TelemedicineContentEs',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'TELEMEDICINA',
          title: 'Atención Primaria General',
          subtitle: 'Atención médica accesible desde la comodidad de su hogar.',
          paragraphs: [
            "Nuestros servicios de telesalud de atención primaria le brindan acceso directo a profesionales médicos experimentados para una amplia variedad de necesidades no urgentes. Ya sea que esté lidiando con una enfermedad común o necesite un resurtido de receta, nuestra clínica virtual ofrece una solución conveniente.",
            "A través de videoconsultas seguras, podemos evaluar sus síntomas, proporcionar diagnósticos precisos y desarrollar planes de tratamiento personalizados, todo sin la necesidad de viajar a una oficina física."
          ],
          list: [
            "Consultas para enfermedades comunes como resfriados, gripe e infecciones",
            "Chequeos de salud de rutina y orientación de atención preventiva",
            "Manejo de condiciones crónicas estables",
            "Renovaciones de recetas y manejo de medicamentos"
          ],
          image: '/images/weight-loss/img-principal-new.webp'
        },
        {
          label: 'SALUD METABÓLICA',
          title: 'Control de Peso',
          subtitle: 'Enfoque integral y basado en evidencia para lograr un peso saludable.',
          paragraphs: [
            "Los programas integrados de control de peso y salud metabólica brindan un enfoque integral para lograr un peso saludable y mejorar la función metabólica. Estos programas difieren de las dietas tradicionales al incorporar supervisión médica, tecnología avanzada para el monitoreo, orientación nutricional y de comportamiento.",
            "Una piedra angular de los programas modernos es el uso de telesalud y herramientas digitales para mejorar el acceso y la responsabilidad. El monitoreo virtual aprovecha la tecnología para rastrear el progreso y brindar soporte continuo."
          ],
          list: [
            "<strong>Supervisión Médica:</strong> Evaluación integral que incluye historial, evaluación y establecimiento de objetivos.",
            "<strong>Monitoreo Virtual:</strong> Seguimiento remoto del paciente rastreando el progreso y brindando soporte continuo.",
            "<strong>Asesoramiento Nutricional:</strong> Planificación de comidas personalizadas, coaching de comportamiento y educación.",
            "<strong>Terapias Supervisadas:</strong> Medicamentos seguros y aprobados por la FDA para bajar de peso recetados por el médico."
          ],
          image: '/images/services/weight-management-telehealth.png'
        },
        {
          label: 'ATENCIÓN ESPECIALIZADA',
          title: "Salud del Hombre y la Mujer",
          subtitle: 'Optimización hormonal personalizada y estrategias de bienestar.',
          paragraphs: [
            "Los desequilibrios hormonales pueden afectar significativamente su calidad de vida, afectando los niveles de energía, el estado de ánimo, el metabolismo y la salud sexual. Nuestra plataforma de telesalud brinda un entorno discreto y cómodo para discutir estos problemas con nuestros proveedores especializados.",
            "Ofrecemos evaluaciones integrales, incluida la revisión del historial médico y la coordinación de los análisis de laboratorio necesarios para evaluar con precisión sus niveles hormonales y desarrollar un plan a medida."
          ],
          list: [
            "Consultas de terapia de reemplazo de testosterona (TRT) para hombres",
            "Terapia de reemplazo hormonal (TRH) y apoyo para la menopausia en mujeres",
            "Manejo de síntomas como fatiga, aumento de peso y baja libido",
            "Monitoreo continuo y ajustes de dosis a través de visitas virtuales"
          ],
          image: '/images/services/hormone-therapy-telehealth.png'
        },
        {
          label: 'BIENESTAR Y APOYO',
          title: 'Salud Mental y Estilo de Vida',
          subtitle: 'Atención compasiva para su bienestar emocional.',
          paragraphs: [
            "La salud mental es un componente vital de su salud en general, y nuestros servicios de telesalud facilitan más que nunca priorizar su bienestar emocional. Desde manejar el estrés diario hasta abordar desafíos de salud conductual más complejos.",
            "Brindamos un espacio virtual seguro y sin prejuicios para discutir sus inquietudes, aprender estrategias de afrontamiento efectivas y trabajar hacia una vida más equilibrada y satisfactoria."
          ],
          list: [
            "Asesoramiento para el manejo del estrés, ansiedad y depresión",
            "Coaching de comportamiento para apoyar cambios de estilo de vida",
            "Estrategias para mejorar la calidad del sueño y desarrollar resiliencia",
            "Integración con nuestros programas de control de peso y nutrición"
          ],
          image: '/images/services/mental-health-telehealth.png'
        }
      ]
    };
  }
};
</script>
